import React from 'react';

export class Home extends React.Component {
  
  render() {
    return (
      <div style={{ margin: 50 }}>
        <div style={{ textAlign: 'center', padding: '300px' }}>
            <h1 style={{ margin: 10 }}>Aditya Hiran Pilla</h1>
            <span>Senior Software Engineer</span>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Home.js